import api from '../Utils/api'

export const fetchMeetings = async (nextPageToken, prevPageToken, limit) => {
  const now = Date.now()
  const body = {
    nextPageToken,
    prevPageToken,
    limit
  }
  const apiResponse = await api('POST', `events/fetch-meetings?${now}`, body)
  return apiResponse
}

export const fetchMeetings2 = async (currentTimestamp) => {
  return (await api('POST', 'events/fetch-meetings', {currentTimestamp}))
}

export const changeAllowBotStatus = async (eventId, status) => {
  const apiResponse = await api('POST', 'events/bot_join', {
    eventId,
    status
  })
  return apiResponse
}

export const fetchLastMeeting = async () => {
  const apiResponse = await api('POST', 'events/fetch-last-meeting', {
    currentTime: new Date().getTime(),
  })
  return apiResponse
}

export const fetchPreviousMeetings = async () => {
  const apiResponse = await api('POST', 'events/fetch-previous-meetings', {
    currentTime: new Date().getTime(),
  })
  return apiResponse
}

export const getVideoDownloadUrl = async (eventId) => {
  const apiResponse = await api(
    'GET',
    `events/download?eventId=${eventId}`,
    null
  )
  return apiResponse
}

export const askSearch = async (search) => {
  const apiResponse = await api('POST', 'events/search', {
    currentTime: new Date().getTime(),
    search: search,
  })
  return apiResponse
}

export const addPrompt = async (eventId, prompt, tab) => {
  const apiResponse = await api('POST', 'events/add-templatised-prompt', {
    eventId,
    prompt,
    tab
  })
  return apiResponse
}

export const getMeetData = async (eventId) => {
  const apiResponse = await api(
    'GET',
    `events/?meetId=${eventId}`,
    null
  )
  return apiResponse
}

export const addComment = async (eventId, comment) => {
  const apiResponse = await api('POST', 'events/add-comment', {
    eventId,
    comment,
  })
  // eslint-disable-next-line no-console
  console.log(apiResponse)
  return apiResponse
}